import { TOP_SELLERS_PERIOD_LABELS, TOP_SELLERS_PERIODS } from '@/lib/dashboard'
import { cn } from '@/lib/utils'
import type { TopSellersPeriod } from '@/api/types'

interface TopSellersPeriodToggleProps {
  period: TopSellersPeriod
  onPeriodChange: (period: TopSellersPeriod) => void
}

interface PeriodOptionProps {
  option: TopSellersPeriod
  isActive: boolean
  onPeriodChange: (period: TopSellersPeriod) => void
}

const optionBaseClass = 'rounded-full px-3 py-1 text-xs font-medium transition-colors cursor-pointer'
const activeOptionClass = 'bg-background text-foreground shadow-sm'
const inactiveOptionClass = 'text-muted-foreground hover:text-foreground'

function PeriodOption({ option, isActive, onPeriodChange }: PeriodOptionProps): React.ReactElement {
  const optionClass = isActive ? activeOptionClass : inactiveOptionClass

  const handleClick = (): void => {
    onPeriodChange(option)
  }

  return (
    <button
      type="button"
      role="radio"
      aria-checked={isActive}
      onClick={handleClick}
      className={cn(optionBaseClass, optionClass)}
    >
      {TOP_SELLERS_PERIOD_LABELS[option]}
    </button>
  )
}

export function TopSellersPeriodToggle({ period, onPeriodChange }: TopSellersPeriodToggleProps): React.ReactElement {
  return (
    <div
      role="radiogroup"
      aria-label="Period för säljartopplistan"
      className="inline-flex items-center gap-0.5 rounded-full border border-border/80 bg-muted/50 p-0.5"
    >
      {TOP_SELLERS_PERIODS.map((option) => (
        <PeriodOption
          key={option}
          option={option}
          isActive={option === period}
          onPeriodChange={onPeriodChange}
        />
      ))}
    </div>
  )
}
